@if(isStandardUser()) {
<div class="navbar" id="header">
    <button id="sidebarCollapse" class="navbar-toggler" type="button" (click)="toggleSidebar()">
        &#9776;
    </button>
    <a class="navbar-logo" routerLink="/home">
        <img src="img/CA-Colour.svg" class="top-logo" alt="Camp America">
    </a>
    <button class="nav-help profile-pic" type="button" (click)="toggleProfileMenu()">
        @if(profileImage) {
        <img [src]="profileImage | cloudimageFaceCrop:40:40" class="fa image">
        }@else {
        <img src="img/icons/Top_Nav_Profile.png" class="fa image" width="40px" height="40px">
        }
    </button>
</div>
@if(pmopened) {
<app-account-menu (menuItemClicked)="navigateTo($event)" (signOutClicked)="signOut()"></app-account-menu>
}
} @else {
<div class="navbar" id="header">
    <div class="logo-container">
        <img src="img/Homepage Logo.png" class="no-user-logo" alt="Camp America">
    </div>
</div>
}